import React, { useState } from 'react';
import { connect } from 'react-redux';
import TransferExitInformation from './TransferExitInformation';
import { getServiceHierarchyLabel } from '../ReissueTicket';

function Services(props){

    const [transferInfo, transferTicket] = useState('default')

    const { services, users, sessions } = props
    let onlineServices = [], offlineServices = []
    let onlineAgents = sessions
        .filter( session => Number(session.status) === 1) 
        .map( session =>  users
            .find( agent => session.userId === agent.id )
        ).filter(Boolean)

    // folders only group services, they can't take a ticket
    services.filter( service => service.type !== 'folder' ).forEach( service => {
        var count = 0
        onlineAgents.forEach( agent => { if( agent.services.includes(service.id) ){ count++ } })
        service.users = count
        if( count ){ onlineServices.push(service) }
        else { offlineServices.push(service) }
    })


    switch (transferInfo.case){
        case 'exit':
        return (<div className="home-right-content1">
            <div className="titleBlock icon withBackBtn">
                <div className="iconWrapper" onClick={ () => transferTicket({case: 'default' }) }><ion-icon name="arrow-back-outline"></ion-icon></div>
                <h5>Transfer to Service</h5>
                <h5>Back</h5>
            </div>
            <TransferExitInformation transferInfo={transferInfo} returnFunction={transferTicket} />
        </div>)
        default:
        return(
            <div className="home-left-content5-wraper">
                <div className="titleBlock icon withBackBtn">
                    <div className="iconWrapper" onClick={ () => props.returnFunction('default')}>
                        <ion-icon name="arrow-back-outline"></ion-icon>
                    </div>
                    <h5>{ onlineServices.length } Service{ onlineServices.length !== 1 ? 's' : '' } Online</h5>
                    <h5>Back</h5>
                </div>
                <div className="usersListContainer">
                    <div className="user-list-online">
                    {onlineServices.map((data, index) => {
                        var inititals = data.name.split(" ").map( (data, index) => index < 2 ? data.charAt(0) : null )
                        return(
                            <div className="user-list" key={index} onClick={ () => transferTicket({ case: 'exit', type:'service', id: data.id }) }>
                                <div className="user-name-and-pic">
                                    <div>
                                        <div>
                                            <span className="status-badge"></span>
                                            <span className="user-image-text">{ inititals }</span> 
                                        </div>
                                        <p>{ getServiceHierarchyLabel(data, services) }</p>
                                    </div>
                                </div>
                                <div className="user-list-content"><p>{ data.users } Agent{ data.users !== 1 ? 's' : '' }</p></div>
                                <div className="user-list-check"><ion-icon name="checkmark-circle-outline"></ion-icon></div>
                            </div>
                        )
                        })}
                    </div>

                    <div className="user-list-offline">
                    {offlineServices.map((data, index) => {
                        var inititals = data.name.split(" ").map( (data, index) => index < 2 ? data.charAt(0) : null )
                        return(
                            <div className="user-list" key={index}>
                                <div className="user-name-and-pic">
                                    <div>
                                        <div>
                                            <span className="status-badge"></span>
                                            <span className="user-image-text">{ inititals }</span> 
                                        </div>
                                        <p>{ getServiceHierarchyLabel(data, services) }</p>
                                    </div>
                                </div>
                                <div className="user-list-content"><p>0 Agents online</p></div>
                                <div className="user-list-check"><ion-icon name="checkmark-circle-outline"></ion-icon></div>
                            </div>
                        )
                        })}
                    </div>

                </div>
                

            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        users: state.users.users,
        authenticatedUser: state.auth.authenticatedUser,
        sessions: state.sessions.sessions,
        supportDesks: state.services.supportDesks,
        services: state.services.services,
    }
}
export default connect(mapStateToProps, {})(Services);